import { render, staticRenderFns } from "./signRecords.vue?vue&type=template&id=f60dc0ae&scoped=true&"
import script from "./signRecords.vue?vue&type=script&lang=js&"
export * from "./signRecords.vue?vue&type=script&lang=js&"
import style0 from "./signRecords.vue?vue&type=style&index=0&id=f60dc0ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60dc0ae",
  null
  
)

component.options.__file = "signRecords.vue"
export default component.exports